import { useEffect, useState } from "react";
import infoIcon from "../../assets/imgs/consenso-info-icon.png";
import "./style.css";

export const Consenso = ({
    name = "",
    textPreview = "",
    showInfoIcon = true,
    onInfoIconClick = () => {},
    defaultValue = "",
    onChange = () => {},
    classList = "",
    optionsList = [
        {
            label: "Rifiuto",
            value: "0",
        },
        {
            label: "Acconsento",
            value: "1",
        },
    ],
}) => {
    const [checked, setChecked] = useState(defaultValue);

    useEffect(() => {
        setChecked(defaultValue);
    }, [checked, defaultValue]);

    return (
        <>
            <div className={`tos-item-component ${classList}`} name={name}>
                {showInfoIcon && <img className="tos-item-component__info-icon" src={infoIcon} onClick={onInfoIconClick} />}

                <div className="tos-item-component__preview-text" dangerouslySetInnerHTML={{ __html: textPreview }}></div>

                <br />

                <div className={`tos-item-component__header ${checked == "1" ? "checked" : "unchecked"}`}>
                    {optionsList &&
                        optionsList.length > 0 &&
                        optionsList.map((opt, idx) => {
                            return (
                                <div className="consentOption" key={"consent" + idx}>
                                    <label htmlFor={`${name}-${opt.value}-no`}>
                                        <span>{opt.label}</span>
                                        <input
                                            onClick={() => {
                                                setChecked(opt.value);
                                                onChange(opt.value);
                                            }}
                                            id={`${name}-${opt.value}-no`}
                                            type="radio"
                                            name={name}
                                            value={opt.value}
                                            checked={checked == opt.value}
                                        />
                                    </label>
                                </div>
                            );
                        })}
                </div>
            </div>
        </>
    );
};
